'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MPPHeading = require('../../../atoms/heading/jsx/MPPHeading');

var _MPPHeading2 = _interopRequireDefault(_MPPHeading);

var _accordion = require('../../accordion');

var _FaqContent = require('../../../molecules/faq-content/jsx/FaqContent');

var _FaqContent2 = _interopRequireDefault(_FaqContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var Faq = function (_React$Component) {
  _inherits(Faq, _React$Component);

  function Faq() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Faq);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Faq.__proto__ || Object.getPrototypeOf(Faq)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          'div',
          { className: 'text-xs-center' },
          _react2.default.createElement(
            _MPPHeading2.default,
            { level: '2', className: 'faq__headline' },
            htmlToReactParser.parse(headline.text)
          )
        );
      }
      return null;
    }, _this.renderFaqHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _MPPHeading2.default,
          { level: '4', className: 'faq__sectionheadline pp-sans-small-regular' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Faq, [{
    key: 'renderFaqItems',
    value: function renderFaqItems(faqs) {
      var _this2 = this;

      if (faqs) {
        var items = faqs.map(function (faq, faqIndex) {
          var Element = {
            FaqContent: _FaqContent2.default
          }[faq.item && faq.item.config && faq.item.config.type] || _FaqContent2.default;
          var faqKey = '' + faq.headline + faqIndex;
          return _react2.default.createElement(
            _accordion.AccordionItem,
            { key: faqKey },
            _react2.default.createElement(
              _accordion.AccordionHeader,
              null,
              _this2.renderFaqHeadline(faq.headline)
            ),
            _react2.default.createElement(
              _accordion.AccordionContent,
              null,
              _react2.default.createElement(Element, faq.item)
            )
          );
        });
        return items;
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          headline = _props$content.headline,
          faqs = _props$content.faqs;
      var _props$config = this.props.config,
          id = _props$config.id,
          theme = _props$config.theme,
          openItems = _props$config.openItems;

      var faqAccordionClasses = (0, _classnames2.default)('faq', theme, this.props.className);

      return _react2.default.createElement(
        'section',
        { className: faqAccordionClasses, id: id, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.renderHeadline(headline),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'center-block col-xs-12 faq__column' },
              _react2.default.createElement(
                _accordion.Accordion,
                { openItems: openItems || 0 },
                this.renderFaqItems(faqs)
              )
            )
          )
        )
      );
    }
  }]);

  return Faq;
}(_react2.default.Component);

exports.default = Faq;


Faq.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-white']).isRequired,
    openItems: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.number])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    faqs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      headline: {
        text: _propTypes2.default.string.isRequired
      }.isRequired,
      item: _propTypes2.default.oneOfType([_propTypes2.default.shape(_FaqContent2.default.propTypes).isRequired]).isRequired
    })).isRequired
  }),
  className: _propTypes2.default.string
};

Faq.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-blue'
  },
  content: {
    headline: {
      text: '30 characters maximum'
    },
    faqs: [{
      headline: {
        text: '106 characters maximum to not equal more than ' + '2 lines in a mobile view is recommended for ideal viewing.'
      },
      item: _FaqContent2.default.defaultProps
    }, {
      headline: {
        text: '106 characters maximum to not equal more than ' + '2 lines in a mobile view is recommended for ideal viewing.'
      },
      item: _FaqContent2.default.defaultProps
    }]
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/faq/jsx/Faq.js
// module id = 1088
// module chunks = 4